import React from 'react';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { event } from '@uhg-abyss/web/tools/event';
// import { ClaimsNotification } from '@sde/widgets-claims/src/widgets/ClaimsNotification';
import { useProvider } from 'src/state/provider';

export const ClaimsNotificationWidget = () => {
  const { provider } = useProvider.state();
  const router = useRouter();
  const widgetProps = {
    data: {
      provider,
    },
    events: {
      handleClick: () => {
        event('VIEW_CLAIMS_CLICK');
        router.navigate('/claims/trackit/smart-edits-tab');
      },
    },
  };

  // return <ClaimsNotification {...widgetProps} />;
  // TODO: Remove this when the ClaimsNotification widget is supported in Breakout
  return null;
};
